import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { Issue } from '@eadsysteme/issuetrackingclient-v1';

@Injectable({
	providedIn: 'root',
})
export class TicketManagementSessionService {
	searchText: string = '';
	showClosedChecked: boolean = false;
	paginatorItemsPerPage: number = 10;
	paginatorSelectedPage: number = 0;
	checkedTickets = new SelectionModel<Issue>(true, []);
	sortActive: string = 'date';
	sortDirection: SortDirection = 'asc';

	clearSession() {
		this.searchText = '';
		this.showClosedChecked = false;
		this.paginatorItemsPerPage = 10;
		this.paginatorSelectedPage = 0;
		this.checkedTickets = new SelectionModel<Issue>(true, []);
		this.checkedTickets.clear();
		this.sortActive = 'date';
		this.sortDirection = 'asc';
	}
}
